(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3173],{

/***/ 8239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ OrganizationPage; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/LinkText/index.tsx
var LinkText = __webpack_require__(41705);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/index.tsx + 3 modules
var Ir = __webpack_require__(82319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Heading.tsx
var Heading = __webpack_require__(3319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(81507);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Governance/Organization/index.tsx












var OrganizationPage = function OrganizationPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      enTitleText: "Overview of Corporate Governance System"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "The overview of the corporate governance structure and the reasons for adopting this system"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "1. Board of Directors"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
        children: ["The Board of Directors, chaired by Representative Director and President Hiro Nagata and composed of all directors listed in ", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
          path: "/en/company/officer",
          text: "Board of Directors"
        }), ", meets regularly once a month and hold additional meetings as needed. The Board of Directors reports monthly financial results and deliberates on matters stipulated in the Companies Act and the Board of Directors Regulations. The specific details of business execution, background strategies, and policies for important matters are deliberated, and based on the results of these deliberations, the chief executive officer makes decisions."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "2. Audit & Supervisory Board"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
        children: ["By attending important meetings such as the monthly meetings of the Board of Directors, the corporate auditors confirm the status of business execution by each director and express appropriate opinions as necessary to ensure compliance with laws and regulations that must be observed in business execution, thereby fulfilling a check-and-balance function. The Board of Auditors is chaired by Takeshi Agari, a Standing Corporate Auditor, and consists of all the auditors listed in ", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
          path: "/en/company/officer",
          text: "Board of Directors"
        }), ". To improve management transparency and strengthen the management oversight function, two part-time corporate auditors are outside corporate auditors. Each corporate auditor has expertise and experience in general management, accounting, and corporate legal affairs, etc. The Company has adopted the current system based on the judgment that the appointment of the two part-time corporate auditors as independent officers will sufficiently ensure the objectivity and neutrality of the management oversight function in decision making regarding the Company's management and business execution."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "3. Internal Audit Department"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "The Company has an Internal Audit Office, which is independent of the business divisions. Our consolidated subsidiary, TRIAL Company, Inc. and Seiyu Co., Ltd., has an Internal Audit Department, which together consists of a total of 15 members (as of June 30, 2026). Based on an annual audit plan, internal audits are conducted covering a broad range of operations at business locations and head office departments. The results of the audits are reported in writing to the President and, in principle, shared with the Standing Audit & Supervisory Board Member once a month. The results are also reported to the Board of Directors as necessary. The departments subject to audit are instructed to make improvements based on the audit findings, and their progress in implementing such improvements is reported without delay and subsequently verified. In addition, information on audit matters and other issues is shared with the Standing Audit & Supervisory Board Member as appropriate."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "4. Accounting Auditor"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "The Company has entered into an audit contract with PricewaterhouseCoopers Japan LLC,  and timely and appropriate audits are conducted. There are no special interests between the Company and the said audit firm or the managing partners of the said firm who are engaged in auditing the Company."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "5. Management Conference"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "The Management Conference is chaired by Representative Director and President Hiro Nagata and consists of full-time directors, full-time corporate auditor and exeutive officers. The Management Conference is held once a month for the purpose of prompt and efficient decision-making, to deliberate and review important management matters affecting the entire company, to confirm the progress of business performance, and to share various important communications."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "6. Investment Advisory Committee"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "We have the Investment Advisory Committee as an optional advisory body under the Board of Directors to deliberate on important investment projects such as M&A, real estate acquisitions, and IT investments. The committee is composed of executive officers responsible for finance, corporate planning, and risk management, among others, with the executive officer in charge of the corporate strategy division serving as chairperson. Important investment projects are consulted with this committee in advance, and the Board of Directors makes decisions giving maximum respect to its recommendations."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "7. Nomination and Compensation Advisory Committee"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "In order to strengthen the independence, objectivity and accountability of the Board of Directors' functions regarding the nomination (including succession planning) and compensation of senior management and officers, the Company has established the Nomination and Compensation Advisory Committee as a voluntary advisory body under the Board of Directors with a majority of independent outside directors (one full-time director (Hiro Nagata) and two independent outside directors (Hirofumi Tatsumoto and Chang Sangsoo) and chaired by independent outside director Chang Sangsoo. The selection and dismissal of management executives and directors, as well as their compensation, are discussed with this committee in advance, and decisions are made by the Board of Directors with the utmost respect for the committee's recommendations."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "8. Group Risk Compliance Committee"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "This committee is established with the purpose of minimizing losses related to risk and compliance, including identifying risk events and compliance issues across the company, and deliberating on countermeasures in the event of serious compliance incidents or accidents. Regular meetings are held quarterly in principle, and extraordinary meetings are convened as needed."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "9. Information Security Committee"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "This committee is established for the purpose of company-wide review of information security and deliberation on countermeasures in the event of security incidents or accidents. Regular meetings are held four times a year in principle."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "10. Harassment Committee"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "This committee is established with the purpose of preventing harassment cases, ensuring appropriate handling of cases, and formulating recurrence prevention measures. Meetings are held once a week in principle."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "11. Disciplinary Committee"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "This committee is established to ensure fair treatment in deciding the necessity and severity of disciplinary action against individuals involved in misconduct by employees. The chairperson convenes meetings as needed."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* CHeading */.V, {
        children: "12. Related Party Transaction Review Committee"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "This committee is established with the objective of identifying related party transactions in advance and verifying the necessity and appropriateness of such transactions. Meetings are held once a month in principle. The committee is chaired by the executive in charge of the Governance Department, and its transparency is ensured by having other members of outside directors or audit & supervisory board members appointed by a resolution of the Board of Directors."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: "/images/TRIAL_Corporate_Governance_System_EN.png",
        alt: "\u682A\u4E3B\u7DCF\u4F1A",
        width: "100%"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 50,
          pc: 80
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "The reasons for adopting a corporate governance structure"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "In September 2021, the Company transitioned to a Company with an Audit & Supervisory Board, with the aim of ensuring transparency in our management structure and further enhancing and strengthening corporate governance. As of September 24, 2026, by having two out of four directors as outside directors, we receive advice and recommendations from an objective standpoint in various specialized fields, while also strengthening the supervisory functions of the Board of Directors. Furthermore, by having two out of three Audit & Supervisory Board members as outside Audit & Supervisory Board members, we ensure the objectivity and neutrality of our management monitoring functions. In addition to these measures, we have established a Nomination and Remuneration Advisory Committee, composed predominantly of outside directors, and a management conference body called \"Management Conference,\" primarily consisting of internal directors, Audit & Supervisory Board members, and executive officers. Through these initiatives, we have built a system that ensures management transparency while enabling agile management through rapid decision-making."
      })]
    })]
  });
};

OrganizationPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Investor Relations',
    path: '/en/ir'
  }, {
    name: 'Corporate Governance',
    path: '/en/ir/governance/'
  }, {
    name: 'Overview of Corporate Governance System',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Overview of Corporate Governance System",
      description: "An overview of the corporate governance structure and the reasons for adopting this system.",
      ogp: {
        url: 'en/ir/governance/organization/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Organization__Image",
  componentId: "sc-ufcwnk-0"
})(["height:100%;"]);
;// CONCATENATED MODULE: ./src/pages/en/ir/governance/organization.tsx


/***/ }),

/***/ 78891:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/governance/organization",
      function () {
        return __webpack_require__(8239);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,4591,4123,9774,2888,179], function() { return __webpack_exec__(78891); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);